import { render, staticRenderFns } from "./AddMensalista.vue?vue&type=template&id=b617c2b6&scoped=true&"
import script from "./AddMensalista.vue?vue&type=script&lang=js&"
export * from "./AddMensalista.vue?vue&type=script&lang=js&"
import style0 from "./AddMensalista.vue?vue&type=style&index=0&id=b617c2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b617c2b6",
  null
  
)

export default component.exports